import { connect } from "react-redux";
import { ToggleView as Component, ToggleViewProps } from "./ToggleView.component";
import { RootState } from "../../../../reducers";
import { changeLocationRouterView } from "../../../LocationRouter/actions";
import { getLocationRouterView } from "../../../LocationRouter/selectors";

const mapStateToProps = (state: RootState) => ({
  view: getLocationRouterView(state)
} as Pick<ToggleViewProps, "view">);

export const ToggleView = connect(mapStateToProps, {
  changeView: (data) => changeLocationRouterView(data),
} as Pick<ToggleViewProps, "changeView">)(Component);
